import React from "react";
import { Input } from "../../ui/input";
import { FlipHorizontal, FlipVertical } from "lucide-react";
import * as Toggle from "@radix-ui/react-toggle";

const iconsObjects = [
  {
    key: "flipVertically",
    component: FlipVertical,
    title: "Flip Vertically",
    canvasKey: "flipY",
  },
  {
    key: "flipHorizontally",
    component: FlipHorizontal,
    title: "Flip Horizontally",
    canvasKey: "flipX",
  },
];

const Rotation = ({ handleInputChange, elementAttributes }: any) => {
  const handleFlipToggle = (key: string) => {
    const canvasKey = key === "flipVertically" ? "flipY" : "flipX";
    const currentValue = elementAttributes[canvasKey];

    handleInputChange(canvasKey, !currentValue);
  };

  return (
    <div>
      <div className="flex flex-col gap-3 border-b border-borderColor py-5 px-2">
        <div className="flex gap-x-1 w-full ">
          <div className="flex flex-col items-start w-1/2 rounded-sm">
            <h3 className="text-[10px] uppercase mb-2">Rotation</h3>
            <Input
              type="number"
              id={"angle"}
              placeholder={"0"}
              value={elementAttributes.angle || 0}
              className="input-ring bg-transparent text-white placeholder"
              onChange={(e) => handleInputChange("angle", e.target.value)}
              // min={0}
            />
          </div>

          <div className="flex flex-col items-start   w-1/2 rounded-sm">
            <h3 className="text-[10px] uppercase mb-2 px-1">Flip</h3>

            <div className="flex flex-row h-[40px] w-full rounded-md items-center justify-evenly gap-1">
              {iconsObjects.map((icon) => (
                <Toggle.Root
                  pressed={elementAttributes[icon.canvasKey]}
                  title={icon.title}
                  key={icon.key}
                  aria-label={icon.title}
                  onPressedChange={() => {
                    handleFlipToggle(icon.key);
                  }}
                  className="hover:bg-black color-red-200 data-[state=on]:bg-black  data-[state=on]:text-primary  flex h-[40px] w-[40px] items-center justify-center rounded-md border"
                >
                  <icon.component size={22} />
                </Toggle.Root>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Rotation;
